let duration = 600
let frameTime = 1000 / 60
let nFrames = Math.round(duration / frameTime)
let percentIncrement = 100 / nFrames
let subnavs

let $toggles = document.querySelectorAll('.js-toggle-sub-nav')

class SubNav {
  constructor ($toggle, index) {
    this.$toggle = $toggle
    this.index = index
    this.$el = $toggle.nextElementSibling
    this.$inner = this.$el.querySelector('div')
    this.$style = document.createElement('style')
    document.head.appendChild(this.$style)

    this.open = false

    this.$toggle.addEventListener('click', this.toggle.bind(this))
  }
  async toggle (e) {
    e && e.preventDefault()

    this.$el.style.animationName = ''
    this.$inner.style.animationName = ''
    // void window.getComputedStyle($el).transform

    if (this.index === 0 && subnavs[1].open) {
      subnavs[1].toggle()
      await wait(500)
    } else if (this.index === 0 && subnavs[2].open) {
      subnavs[2].toggle()
      await wait(500)
    } else if (this.index === 1 && subnavs[0].open) {
      subnavs[0].toggle()
      await wait(500)
    } else if (this.index === 1 && subnavs[2].open) {
      subnavs[2].toggle()
      await wait(500)
    } else if (this.index === 2 && subnavs[0].open) {
      subnavs[0].toggle()
      await wait(500)
    } else if (this.index === 2 && subnavs[1].open) {
      subnavs[1].toggle()
      await wait(500)
    }

    if (window.innerWidth < 1060) {
      this.$el.hidden = false
      this.$el.classList.add('expanded')
      this.$el.closest('nav').classList.add('nav-shifted')
      this.$el.querySelector('.js-sub-nav-back').addEventListener(
        'click',
        once(() => {
          this.$el.closest('nav').classList.remove('nav-shifted')
          window.setTimeout(() => {
            this.$el.classList.remove('expanded')
            this.$el.hidden = true
          }, 400)
        })
      )
      return
    }

    let expanded

    let outerAnim = []
    let innerAnim = []

    if (this.$el.hidden) this.$el.hidden = false
    let first = this.$el.getBoundingClientRect()
    if (this.$el.classList.contains('expanded')) {
      this.$el.classList.remove('expanded')
      expanded = false
    } else {
      this.$el.classList.add('expanded')
      expanded = true
    }
    let last = this.$el.getBoundingClientRect()
    let y = first.height / last.height

    for (let i = 0; i <= nFrames; i++) {
      let step = ease(i / nFrames).toFixed(5)
      let percentage = (i * percentIncrement).toFixed(5)
      let startY = y
      let endY = 1

      let yScale = (startY + (endY - startY) * step).toFixed(5)
      let invScaleY = (1 / yScale).toFixed(5)

      outerAnim.push(`
    ${percentage}% {
      transform: scaleY(${yScale});
    }
  `)

      innerAnim.push(`
    ${percentage}% {
      transform: scaleY(${invScaleY});
    }
  `)
    }

    this.$style.textContent = `
  @keyframes subnavAnimation${this.index} {
    ${outerAnim.join('')}
  }

  @keyframes subnavContentsAnimation${this.index} {
    ${innerAnim.join('')}
  }
`

    if (expanded) {
      this.$toggle.setAttribute('aria-expanded', 'true')
    } else {
      this.$toggle.setAttribute('aria-expanded', 'false')
    }

    this.open = expanded

    this.$el.style.animationName = 'subnavAnimation' + this.index
    this.$inner.style.animationName = 'subnavContentsAnimation' + this.index

    return new Promise(resolve => {
      this.$el.addEventListener(
        'animationend',
        once(e => {
          if (e.animationName === 'subnavAnimation' + this.index) {
            if (!expanded) {
              this.$el.hidden = true
            }
            resolve()
            return true
          }
        })
      )
    })
  }
}

function clamp (value, min, max) {
  return Math.max(min, Math.min(max, value))
}

function ease (v, pow = 4) {
  v = clamp(v, 0, 1)

  return 1 - Math.pow(1 - v, pow)
}

if ($toggles.length) {
  subnavs = Array.from($toggles).map(($toggle, i) => new SubNav($toggle, i))
}

function once (fn, context) {
  let result

  return function () {
    if (fn) {
      result = fn.apply(context || this, arguments)
      if (result) {
        fn = null
      }
    }

    return result
  }
}

function wait (ms) {
  return new Promise(resolve => {
    window.setTimeout(resolve, ms)
  })
}



// WEBPACK FOOTER //
// ./src/js/_sub-nav.js